<template>
  <div class="page-content">
    <el-tabs style="height: 90%" v-model="activeName" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="场地管理" name="siteManagement">
        <site-management ref="siteManagement" class="site-management"></site-management>
      </el-tab-pane>
      <el-tab-pane label="租赁合同管理" name="lease">
        <lease ref="lease"></lease>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import siteManagement from './siteManagement.vue'
import lease from './lease.vue'
export default {
  name: 'leaseContractManagement',
  components: {
    siteManagement,
    lease
  },
  data () {
    return {
      activeName: 'siteManagement'
    }
  },
  methods: {
    handleTabClick (el) {
      this.$refs[el.name].handleQuery()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  margin: 16px;
  padding: 16px;
  width: calc(100% - 32px);
  height: calc(100% - 32px);
  background-color: #fff;
  box-sizing: border-box;
}
.site-management {
  height: 700px;
}
</style>
